/* eslint-disable no-useless-escape */
/* eslint-disable no-prototype-builtins */
import React, { useEffect, useRef, useState, useCallback } from 'react';
import update from 'immutability-helper';
import { connect, ConnectedProps } from 'react-redux';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
    useIntl,
} from 'react-intl';
import { usePiTracker } from '../../../hooks/pi-tracker';
import { RootState } from '../../../store';
import {
    IAudiogramResponse,
    IOption,
    IOrderDetails,
    IProductDetail,
    IReceiverPart,
    receiverFitTypes,
    ISelectedOptionIds,
    sides,
    StateResult,
    IProductHoverImage,
    ICustomColor,
    OptionTypes,
    IAccessoryOrder,
} from '../../../models/product-detail';
import {
    adjustFeaturesAction,
    clearAdjustFeatures,
} from '../../../store/order/order-actions';
import { IPatient } from '../../../models/prosites';
import { loadConstants } from '../../../store/externals/externals-actions';
import ProductOptions from '../../e-store/product-details/product-options';
import {
    addToCart,
    clearProductDetails,
    loadProductDetails,
} from '../../../store/product/product-detail-actions';
import { loadSession } from '../../../store/session/session-actions';
import { CartItemTypes, APIDs, US } from '../../common/constants';
import RowElementWrapper from '../../common/row-element-wrapper';
import ColorSelector, {
    prepareCustomImageUrl,
} from '../../e-store/product-details/color-selector';
import EarmoldOptions from '../../e-store/product-details/earmold-options';
import ErrorsMessageBox from '../../e-store/product-details/errors-section';
import LongDescription from '../../e-store/product-details/long-description';
import StarkeyChoice from '../../e-store/product-details/options-components/starkey-choice';

import {
    findOption,
    rulesInit,
    runEarmoldConditions,
    extractDefaultOptions,
    loadOptionsAndRules,
    fetchEarmoldOptions,
    addIncludedAccessoriesDisplay,
    showHideEarmolOptionsBasedOnCROS,
    isAvailable,
    parseSide,
} from '../../e-store/product-details/rules-engine';
import SpecialInstructions from '../../e-store/product-details/special-instructions';
import ThresholdSection, {
    getRoundedAudiogramValue,
} from '../../e-store/product-details/threshold-section';
import IsValid, {
    ProductOrderFormErrors,
} from '../../e-store/product-details/validation';
import { parseTransferPatient } from '../../common/transfer-patient-alert';
import { useCookies } from 'react-cookie';
import { InspireTransferPatient } from '../../../models/inspire-transfer-patient';
import { setIsBusy } from '../../../store/api/api-status-action';
import { useHistory } from 'react-router';
import ModalXLarge from '../../common/modal-xl';
import { IOrderDLineNumOpts, IProductCatalogID } from '../../../models/order';
import { orderHold } from '../../../api/order-api';
import Modal from '../../common/modal';
import { starkeyChoiceHook } from '../../../hooks/starkey-choice-hook';
import {
    useHandleToggleFavorite,
    useIsFavorite,
} from '../../../hooks/use-is-favorite';
import { resetLeftCable } from '../../../hooks/reset-left-cable';

interface IUpdateDetailsProps {
    onClose: () => void;
    onAccept: () => void;
}
type Props = PropsFromRedux & IUpdateDetailsProps;
export const UpdateDetails = ({
    productDetails,
    agreementName,
    agreementInfo,
    patientNumberRequired,
    session,
    onClose,
    onAccept,
    clearProductDetails,
    setIsBusy,
    loadConstants,
    adjustFeaturesAction,
    clearAdjustFeatures,
    constants,
    spaPath,
    order,
    updateOptionData,
    adjustFeaturesResponse,
}: Props) => {
    const intl = useIntl();
    let orderDetails: IOrderDetails | null;
    let patientDetails: IPatient | null;
    const lines: IOrderDLineNumOpts[] = [];
    let receiver: IReceiverPart | null;

    const isFavorite = useIsFavorite();
    const handleToggleFavorite = useHandleToggleFavorite();

    const [cookies] = useCookies(['transferPatient']);
    const [error, setError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [confirmed, setConfirmed] = useState(false);
    const [productDetailState, setProductDetailState] =
        useState<IProductDetail>({ ...productDetails! });

    const [orderState, setOrderState] = useState<IOrderDetails>({
        ...orderDetails!,
    });

    const [errorsState, setErrorsState] = useState<ProductOrderFormErrors>({});
    const errorRef = useRef<any>(null);
    const [addingToCart, setAddingToCart] = useState<boolean>(false);
    const [productHoverImage, setProductHoverImage] =
        useState<IProductHoverImage>();

    const [faceplates, setFaceplates] = useState<ICustomColor[]>([]);
    const [shells, setShells] = useState<ICustomColor[]>([]);
    const prepareCustomColors = (
        colors: IOption[],
        side: string | null,
        allOptions?: boolean
    ) => {
        const colorObject: ICustomColor[] = [];

        const createColorObject = (color: IOption) => {
            return {
                color: color.name
                    .replace(/\ /gi, '-')
                    .toLowerCase()
                    .replace(/\-plate/gi, '')
                    .replace(/\-shell/gi, '')
                    .replace(/\//gi, '-')
                    .replace(/\-\(gfp\)/gi, ''),
                id: color.id,
                colorName: color.name,
                isdefault: color.isDefault!,
                swatchUrl: `/~/media/online-ordering/color%20swatches%20custom/${color.name
                    .replace(/\ /gi, '-')
                    .toLowerCase()
                    .replace(/\-plate/gi, '')
                    .replace(/\-shell/gi, '')
                    .replace(/\//gi, '-')
                    .replace(/\-\(gfp\)/gi, '')}.ashx`,
            };
        };

        side = parseSide(side);

        colors.forEach((x) => {
            if (allOptions) {
                colorObject.push(createColorObject(x));
            } else if (side && isAvailable(x, side)) {
                colorObject.push(createColorObject(x));
            } else if (x.isAvailableLeft && x.isAvailableRight) {
                colorObject.push(createColorObject(x));
            }
        });

        return colorObject;
    };

    const getCustomColorOptions = (
        colorOptions: IOption[],
        optionType: OptionTypes
    ): IOption[] => {
        return colorOptions.find(
            (optionCategory) => optionCategory.id === optionType
        )!.items[0].items;
    };

    const prepareFaceplatesAndShells = (options: IOption[]) => {
        if (
            [CartItemTypes.CustomOnly, CartItemTypes.SoundGearCustom].includes(
                productDetailState.cartItemTypeId!
            )
        ) {
            const faceplateColors = getCustomColorOptions(
                options,
                OptionTypes.FaceplateColor
            );
            setFaceplates(
                prepareCustomColors(faceplateColors, orderState.side)
            );
        }

        const shellColors = getCustomColorOptions(
            options,
            OptionTypes.ShellColor
        );

        setShells(prepareCustomColors(shellColors, orderState.side));
    };

    const handleFacePlateImageHover = (hoverProduct?: IProductHoverImage) => {
        setProductHoverImage(hoverProduct);
    };

    // TODO: change this to use spread operator on patient
    const updatePatientDetails = (patientDetails: IPatient) => {
        setOrderState((prevState) => ({
            ...prevState!,
            patient: { ...prevState.patient!, ...patientDetails },
        }));
    };

    const updatePatientData = (name: string, value: any) => {
        setOrderState((prevState) => ({
            ...prevState,
            patient: { ...prevState.patient!, [name]: value },
        }));
    };

    const updateReceivers = (receiver: IReceiverPart[]) => {
        setOrderState((prevState) => ({
            ...prevState!,
            receivers: receiver,
        }));
    };
    const updateOptionsFromAudiogram = (
        orderState: IOrderDetails | undefined,
        productDetailState: IProductDetail | undefined
    ) => {
        if (orderState && productDetailState) {
            const clonedOrderState: IOrderDetails = JSON.parse(
                JSON.stringify(orderState)
            );
            let rightIds: number[];
            let leftIds: number[];
            let stateResult: StateResult = {
                orderDetails: orderState,
                productDetails: productDetailState,
            };
            if (
                ![
                    CartItemTypes.Earmold,
                    CartItemTypes.BteWithEarmold,
                    CartItemTypes.RicWithEarmold,
                    CartItemTypes.SoundGearEarmold,
                ].includes(clonedOrderState.cartItemTypeId!)
            ) {
                rightIds = clonedOrderState.rightSelectedIds
                    ? clonedOrderState.rightSelectedIds
                    : [];
                leftIds = clonedOrderState.leftSelectedIds
                    ? clonedOrderState.leftSelectedIds
                    : [];

                const starkeyChoiceOptions = productDetailState.options.find(
                    (x) => x.id === 7
                );
                if (starkeyChoiceOptions) {
                    const right = clonedOrderState.patient!.rightLoss;
                    const left = clonedOrderState.patient!.leftLoss;
                    if (
                        [
                            CartItemTypes.CustomOnly,
                            CartItemTypes.RicWithAp,
                            CartItemTypes.ApReceiver,
                        ].includes(clonedOrderState!.cartItemTypeId!)
                    ) {
                        const gainOptions = starkeyChoiceOptions.items.find(
                            (x) => x.id === 9
                        );
                        if (gainOptions) {
                            rightIds = starkeyChoiceHook(
                                gainOptions,
                                right,
                                left,
                                rightIds,
                                leftIds
                            ).rightIds;
                            leftIds = starkeyChoiceHook(
                                gainOptions,
                                right,
                                left,
                                rightIds,
                                leftIds
                            ).leftIds;
                        }

                        stateResult = runRules(
                            {
                                rightSelectedIds: rightIds,
                                leftSelectedIds: leftIds,
                            },
                            false,
                            productDetailState.options,
                            //have to pass binaural because runrules will be reading side from orderState and its not current
                            sides.binaural
                        );
                        let ventOptions = starkeyChoiceOptions.items.find(
                            (x) => x.id === 11
                        );
                        if (stateResult) {
                            rightIds =
                                stateResult.orderDetails!.rightSelectedIds;
                            leftIds = stateResult.orderDetails!.leftSelectedIds;
                            ventOptions = stateResult
                                .productDetails!.options.find(
                                    (x) => x.id === 7
                                )!
                                .items.find((x) => x.id === 11);
                        }
                        if (ventOptions) {
                            if (right && right.vent) {
                                const predictedVent = findOption(
                                    right.vent,
                                    ventOptions.items
                                );
                                if (
                                    predictedVent &&
                                    predictedVent.isAvailableRight
                                )
                                    ventOptions.items.forEach((y) => {
                                        if (y.name === `${right.vent}`) {
                                            if (!rightIds.includes(y.id))
                                                rightIds.push(y.id);
                                        } else {
                                            if (rightIds.includes(y.id))
                                                rightIds.splice(
                                                    rightIds.indexOf(y.id),
                                                    1
                                                );
                                        }
                                    });
                            }
                            if (left && left.vent) {
                                const predictedVent = findOption(
                                    left.vent,
                                    ventOptions.items
                                );
                                if (
                                    predictedVent &&
                                    predictedVent.isAvailableLeft
                                )
                                    ventOptions.items.forEach((y) => {
                                        if (y.name === `${left.vent}`) {
                                            if (!leftIds.includes(y.id))
                                                leftIds.push(y.id);
                                        } else {
                                            if (leftIds.includes(y.id))
                                                leftIds.splice(
                                                    leftIds.indexOf(y.id),
                                                    1
                                                );
                                        }
                                    });
                            }
                        }
                    }
                }
                return stateResult;
            }

            if (
                clonedOrderState!.rightEarmoldIds ||
                clonedOrderState!.leftEarmoldIds
            ) {
                const optionsAfterSyncHearingLoss = runEarmoldConditions(
                    {
                        rightSelectedIds: clonedOrderState.rightEarmoldIds
                            ? clonedOrderState.rightEarmoldIds
                            : [],
                        leftSelectedIds: clonedOrderState.leftEarmoldIds
                            ? clonedOrderState.leftEarmoldIds
                            : [],
                    },
                    productDetailState.earmoldOptions,
                    JSON.parse(JSON.stringify(orderState))
                )!.selectedOptionIds;
                stateResult = runRules(
                    {
                        rightSelectedIds:
                            optionsAfterSyncHearingLoss.rightSelectedIds,
                        leftSelectedIds:
                            optionsAfterSyncHearingLoss.leftSelectedIds,
                    },
                    true,
                    productDetailState.earmoldOptions,
                    //have to pass binaural because runrules will be reading side from orderState and its not current
                    sides.binaural
                );
                return stateResult;
            }
        }
    };

    const updateStarkeyChoiceOrHearingLoss = (
        right: IAudiogramResponse,
        left: IAudiogramResponse
    ) => {
        const stateResult = updateOptionsFromAudiogram(
            orderState,
            productDetailState
        );

        if (stateResult) {
            setOrderState((prevState) => ({
                ...prevState,
                ...stateResult.orderDetails,
            }));
            setProductDetailState((prevState) => ({
                ...prevState,
                ...stateResult.productDetails,
            }));
        }
    };

    const addItemToOrder = async (e: React.MouseEvent<HTMLButtonElement>) => {
        e.preventDefault();

        if (orderState) {
            const errors = IsValid(
                orderState,
                productDetailState!,
                patientNumberRequired,
                session.country,
                true,
                session.siteNumber,
                intl
            );

            if (Object.keys(errors).length === 0) {
                //api call to send order details
                const patient: IPatient | undefined = updateOptionData!.patient;
                if (confirmed) {
                    if (updateOptionData!.cartItem.pair) {
                        const rightIds: IProductCatalogID[] = [];
                        const leftIds: IProductCatalogID[] = [];
                        if (productDetails!.earmoldCategory) {
                            orderState.rightEarmoldIds.forEach((id) =>
                                rightIds.push({ Id: id })
                            );

                            orderState.leftEarmoldIds.forEach((id) =>
                                leftIds.push({ Id: id })
                            );

                            const lineItem1 = {
                                ...updateOptionData!.lineItem[0],
                                partNumber: productDetailState.partNumber,
                                patient: patient
                                    ? {
                                          ...patient,
                                          audiogram:
                                              orderState.patient!.audiogram!,
                                      }
                                    : null,
                                option: rightIds,
                                imageUrl: orderState.selectedImage,
                            };
                            const lineItem2 = {
                                ...updateOptionData!.lineItem[1],
                                partNumber: productDetailState.partNumber,
                                patient: patient
                                    ? {
                                          ...patient,
                                          audiogram:
                                              orderState.patient!.audiogram!,
                                      }
                                    : null,
                                option: leftIds,
                                imageUrl: orderState.selectedImage,
                            };
                            lines.push(lineItem1, lineItem2);

                            setIsBusy(true);
                            await adjustFeaturesAction(
                                true,
                                order!.orderNumber,
                                lines
                            );
                            setIsBusy(false);
                        } else {
                            orderState.rightSelectedIds.forEach((id) =>
                                rightIds.push({ Id: id })
                            );

                            orderState.leftSelectedIds.forEach((id) =>
                                leftIds.push({ Id: id })
                            );
                            const lineItem1 = {
                                ...updateOptionData!.lineItem[0],
                                partNumber: productDetailState.partNumber,
                                patient: patient
                                    ? {
                                          ...patient,
                                          audiogram:
                                              orderState.patient!.audiogram!,
                                      }
                                    : null,
                                option: rightIds,
                                imageUrl: orderState.selectedImage,
                                color: orderState.selectedColor
                                    ? orderState.selectedColor
                                    : productDetailState.color,
                            };
                            const lineItem2 = {
                                ...updateOptionData!.lineItem[1],
                                partNumber: productDetailState.partNumber,
                                patient: patient
                                    ? {
                                          ...patient,
                                          audiogram:
                                              orderState.patient!.audiogram!,
                                      }
                                    : null,
                                option: leftIds,
                                imageUrl: orderState.selectedImage,
                                color: orderState.selectedColor
                                    ? orderState.selectedColor
                                    : productDetailState.color,
                                //leftEarmoldIds: orderState.leftEarmoldIds!,
                                // EarmoldOptions: orderState.earmoldOptions
                            };
                            lines.push(lineItem1, lineItem2);
                            console.log(lines);
                            setIsBusy(true);
                            await adjustFeaturesAction(
                                false,
                                order!.orderNumber,
                                lines
                            );
                            setIsBusy(false);
                        }
                    } else {
                        const monoIds: IProductCatalogID[] = [];
                        if (productDetails!.earmoldCategory) {
                            if (orderState.leftEarmoldIds.length === 0) {
                                orderState.rightEarmoldIds.forEach((id) =>
                                    monoIds.push({ Id: id })
                                );
                            } else {
                                orderState.leftEarmoldIds.forEach((id) =>
                                    monoIds.push({ Id: id })
                                );
                            }

                            const lineItem1 = {
                                ...updateOptionData!.lineItem[0],
                                partNumber: productDetailState.partNumber,
                                patient: patient
                                    ? {
                                          ...patient,
                                          audiogram:
                                              orderState.patient!.audiogram!,
                                      }
                                    : null,
                                option: monoIds,
                                imageUrl: orderState.selectedImage,
                            };

                            lines.push(lineItem1);

                            setIsBusy(true);
                            await adjustFeaturesAction(
                                true,
                                order!.orderNumber,
                                lines
                            );
                            setIsBusy(false);
                        } else {
                            orderState.rightSelectedIds.forEach((id) =>
                                monoIds.push({ Id: id })
                            );

                            const lineItem1 = {
                                ...updateOptionData!.lineItem[0],
                                partNumber: productDetailState.partNumber,
                                patient: patient
                                    ? {
                                          ...patient,
                                          audiogram:
                                              orderState.patient!.audiogram!,
                                      }
                                    : null,
                                option: monoIds,
                                imageUrl: orderState.selectedImage,
                                color: orderState.selectedColor
                                    ? orderState.selectedColor
                                    : productDetailState.color,
                            };

                            lines.push(lineItem1);
                            console.log(lines);
                            setIsBusy(true);
                            await adjustFeaturesAction(
                                false,
                                order!.orderNumber,
                                lines
                            );
                            setIsBusy(false);
                        }
                    }
                }
                setConfirmed(true);
            } else {
                setErrorsState(errors);
                window.scrollTo(0, errorRef.current);
            }
        }
    };

    const runRules = useCallback(
        (
            selectedIds: ISelectedOptionIds,
            isEarmold: boolean,
            options?: IOption[],
            side?: string | null,
            existingStateResult?: StateResult
        ): StateResult => {
            console.log('runRules called');

            const currentSide = parseSide(side || orderState.side || 'B');

            const stateResult: StateResult = existingStateResult
                ? existingStateResult
                : {
                      productDetails: {} as any,
                      orderDetails: {} as any,
                  };

            if (!options || options.length <= 0) {
                if (isEarmold) {
                    // productDetails
                    stateResult.productDetails!.earmoldOptions = [];
                    // orderDetails
                    stateResult.orderDetails!.rightEarmoldIds = [];
                    stateResult.orderDetails!.leftEarmoldIds = [];
                } else {
                    // productDetails
                    stateResult.productDetails!.options = [];
                    // orderDetails;
                    stateResult.orderDetails!.rightSelectedIds = [];
                    stateResult.orderDetails!.leftSelectedIds = [];
                    stateResult.orderDetails!.useManufacturerSelect = true;
                }

                return stateResult;
            }

            const firstRun =
                selectedIds.rightSelectedIds.length === 0 &&
                selectedIds.leftSelectedIds.length === 0;

            const defaultOptions: any = {};
            let updatedSelectedIds: ISelectedOptionIds = JSON.parse(
                JSON.stringify(selectedIds)
            );

            if (
                currentSide !== sides.left &&
                selectedIds.rightSelectedIds.length === 0
            ) {
                [sides.right].forEach((x) =>
                    extractDefaultOptions(
                        { ...defaultOptions, items: options! },
                        x,
                        updatedSelectedIds,
                        false
                    )
                );
                [sides.right].forEach((x) =>
                    addIncludedAccessoriesDisplay(
                        { ...defaultOptions, items: options! },
                        x,
                        updatedSelectedIds
                    )
                );
            }

            if (
                currentSide !== sides.right &&
                selectedIds.leftSelectedIds.length === 0
            ) {
                [sides.left].forEach((x) =>
                    extractDefaultOptions(
                        { ...defaultOptions, items: options! },
                        x,
                        updatedSelectedIds,
                        false
                    )
                );
                [sides.left].forEach((x) =>
                    addIncludedAccessoriesDisplay(
                        { ...defaultOptions, items: options! },
                        x,
                        updatedSelectedIds
                    )
                );
            }

            if (currentSide === sides.right && !orderState.cros) {
                updatedSelectedIds = {
                    rightSelectedIds: updatedSelectedIds.rightSelectedIds,
                    leftSelectedIds: updatedSelectedIds.rightSelectedIds,
                };
            }

            if (currentSide === sides.left && !orderState.cros) {
                updatedSelectedIds = {
                    rightSelectedIds: updatedSelectedIds.leftSelectedIds,
                    leftSelectedIds: updatedSelectedIds.leftSelectedIds,
                };
            }

            const optionsState: IOption[] = JSON.parse(JSON.stringify(options));

            if (firstRun && isEarmold) {
                updatedSelectedIds = showHideEarmolOptionsBasedOnCROS(
                    orderState,
                    updatedSelectedIds
                );
            }

            let rulesResult = rulesInit(
                optionsState,
                updatedSelectedIds,
                isEarmold,
                {
                    rightSelectedIds: isEarmold
                        ? orderState!.rightEarmoldIds && !firstRun
                            ? JSON.parse(
                                  JSON.stringify(orderState!.rightEarmoldIds)
                              )
                            : []
                        : orderState!.rightSelectedIds
                        ? JSON.parse(
                              JSON.stringify(orderState!.rightSelectedIds)
                          )
                        : [],
                    leftSelectedIds: isEarmold
                        ? orderState!.leftEarmoldIds && !firstRun
                            ? JSON.parse(
                                  JSON.stringify(orderState!.leftEarmoldIds)
                              )
                            : []
                        : orderState!.leftSelectedIds
                        ? JSON.parse(
                              JSON.stringify(orderState!.leftSelectedIds)
                          )
                        : [],
                },
                currentSide === sides.binaural
                    ? [sides.right, sides.left]
                    : currentSide === sides.right
                    ? [sides.right]
                    : [sides.left]
            );

            if (firstRun && isEarmold) {
                rulesResult = runEarmoldConditions(
                    rulesResult!.selectedOptionIds,
                    rulesResult!.options,
                    JSON.parse(JSON.stringify(orderState))
                );
            }

            if (rulesResult) {
                if (isEarmold) {
                    // productDetails
                    stateResult.productDetails!.earmoldOptions =
                        rulesResult.options;
                    // orderDetails
                    stateResult.orderDetails!.earmoldOptions =
                        rulesResult.options;
                    stateResult.orderDetails!.rightEarmoldIds =
                        rulesResult.selectedOptionIds.rightSelectedIds;
                    stateResult.orderDetails!.leftEarmoldIds =
                        rulesResult.selectedOptionIds.leftSelectedIds;
                } else {
                    // productDetails
                    stateResult.productDetails!.options = rulesResult.options;
                    // orderDetails
                    stateResult.orderDetails!.productOptions =
                        rulesResult.options;
                    stateResult.orderDetails!.rightSelectedIds =
                        rulesResult.selectedOptionIds.rightSelectedIds;
                    stateResult.orderDetails!.leftSelectedIds =
                        rulesResult.selectedOptionIds.leftSelectedIds;
                    stateResult.orderDetails!.useManufacturerSelect =
                        rulesResult!.selectedOptionIds.rightSelectedIds.includes(
                            782
                        ) &&
                        rulesResult!.selectedOptionIds.leftSelectedIds.includes(
                            782
                        );
                }
            }

            return stateResult;
        },
        [orderState]
    );

    // TODO: change signature to take state result and include other props in state - will also run rules if required.
    const handleOptionsChange = (
        rightSelectedIds: number[],
        leftSelectedIds: number[],
        isEarmold = false,
        earmoldOptionsLoad?: IOption[] | null
    ) => {
        console.log('handleOptionsChange called');
        const selectedIds: ISelectedOptionIds = {
            rightSelectedIds: rightSelectedIds ? rightSelectedIds : [],
            leftSelectedIds: leftSelectedIds ? leftSelectedIds : [],
        };

        const stateResult = runRules(
            selectedIds,
            isEarmold,
            isEarmold
                ? earmoldOptionsLoad === undefined
                    ? productDetailState!.earmoldOptions
                    : earmoldOptionsLoad === null
                    ? undefined
                    : earmoldOptionsLoad
                : productDetailState!.options
        );

        setProductDetailState((prevState) => ({
            ...prevState,
            ...stateResult.productDetails!,
        }));

        setOrderState((prevState) => ({
            ...prevState,
            ...stateResult.orderDetails!,
        }));
    };

    const handleEarmoldDesignIdChange = async (earmoldDesignId?: number) => {
        if (earmoldDesignId && !isNaN(earmoldDesignId)) {
            const earmoldOptions = await fetchEarmoldOptions(
                session!.catalog,
                earmoldDesignId,
                session!,
                productDetails!
            );

            handleOptionsChange([], [], true, earmoldOptions);
            setOrderState((prevState) => ({
                ...prevState,
                earmoldDesignId: earmoldDesignId,
            }));
        } else {
            handleOptionsChange([], [], true);
            setOrderState((prevState) => ({
                ...prevState,
                earmoldDesignId: undefined,
            }));
        }
    };

    const handleOrderTypeChange = (orderType: string) => {
        //running rules to reset CROS selection bug 31861
        const stateresult = runRules(
            { rightSelectedIds: [], leftSelectedIds: [] },
            false,
            getOptions(productDetailState.cartItemTypeId!)
        );

        if (orderType === 'patient') {
            setOrderState((prevState) => ({
                ...prevState!,
                orderType: orderType,
                side: 'B',
                ampQuantityLeft: 1,
                receiverFit: receiverFitTypes.standard,
                receivers: null,
                patient: {
                    ...prevState!.patient!,
                    audiogram: prevState!.patient!.audiogram,
                },
                accessories: setRelatedItemQuantityForPatientOrders(
                    prevState!.accessories
                ),
                ...stateresult.orderDetails,
            }));
        } else {
            setOrderState((prevState) => ({
                ...prevState!,
                orderType: orderType,
                isStockOrder: orderType,
                quantity: 1,
                ampQuantityLeft: 0,
                cartItemTypeId:
                    prevState!.cartItemTypeId === CartItemTypes.BteWithEarmold
                        ? CartItemTypes.BteOnly
                        : [
                              CartItemTypes.RicWithEarmold,
                              CartItemTypes.RicWithAp,
                          ].includes(prevState!.cartItemTypeId!)
                        ? CartItemTypes.RicWithStockReceiver
                        : prevState!.cartItemTypeId!,
                receiverFit: receiverFitTypes.standard,
                side: null,
                receivers: [CartItemTypes.RicWithStockReceiver].includes(
                    productDetailState!.cartItemTypeId!
                )
                    ? [
                          {
                              ...receiver!,
                              useAngledParts: true,
                              quantity: 1,
                          },
                      ]
                    : null,
                warranty: 0,
                ...stateresult.orderDetails,
            }));
        }

        const standardFaceplates = findOption(
            5,
            stateresult.productDetails!.options
        );
        ///making the selected color stick when receiverfit is changed
        if (standardFaceplates && stateresult) {
            const rightOptions = stateresult.orderDetails!.rightSelectedIds;
            const leftOptions = stateresult.orderDetails!.leftSelectedIds;
            standardFaceplates.items.forEach((x) => {
                if (rightOptions.includes(x.id)) {
                    rightOptions.splice(rightOptions.indexOf(x.id), 1);
                }
                if (leftOptions.includes(x.id)) {
                    leftOptions.splice(leftOptions.indexOf(x.id), 1);
                }
            });
            rightOptions.push(
                standardFaceplates.items.find(
                    (x) => x.name === productDetailState.color
                )!.id
            );
            leftOptions.push(
                standardFaceplates.items.find(
                    (x) => x.name === productDetailState.color
                )!.id
            );
        }

        setProductDetailState((prevState) => ({
            ...prevState,
            ...stateresult.productDetails,
        }));
    };

    const setRelatedItemQuantityForPatientOrders = (
        accessories: IAccessoryOrder[]
    ) => {
        return accessories.map((accessory) => {
            const temp = Object.assign({}, accessory);
            if (temp.quantity > 1) {
                temp.quantity = 1;
            }
            return temp;
        });
    };

    const handleSideChange = (side: string) => {
        ///resetting selections if it is CROS
        let stateResult = runRules(
            {
                rightSelectedIds: orderState.cros
                    ? []
                    : orderState.side !== 'L'
                    ? orderState.rightSelectedIds
                    : orderState.leftSelectedIds,
                leftSelectedIds: orderState.cros
                    ? []
                    : orderState.side !== 'R'
                    ? orderState.leftSelectedIds
                    : orderState.rightSelectedIds,
            },
            false,
            productDetailState.options,
            side
        );

        const temp = updateOptionsFromAudiogram(
            { ...orderState, ...stateResult.orderDetails },
            { ...productDetailState, ...stateResult.productDetails }
        );

        if (temp) {
            stateResult = {
                ...stateResult,
                orderDetails: {
                    ...stateResult.orderDetails!,
                    rightSelectedIds:
                        temp.orderDetails!.rightSelectedIds ||
                        stateResult.orderDetails!.rightSelectedIds,
                    leftSelectedIds:
                        temp.orderDetails!.leftSelectedIds ||
                        stateResult.orderDetails!.leftSelectedIds,
                    rightEarmoldIds: temp.orderDetails!.rightEarmoldIds,
                    leftEarmoldIds: temp.orderDetails!.leftEarmoldIds,
                },
            };
        }

        if (
            [
                CartItemTypes.BteWithEarmold,
                CartItemTypes.RicWithEarmold,
                CartItemTypes.Earmold,
                CartItemTypes.SoundGearEarmold,
            ].includes(orderState.cartItemTypeId!) &&
            !orderState.cros
        ) {
            stateResult = runRules(
                {
                    rightSelectedIds:
                        orderState.side !== 'L'
                            ? orderState.rightEarmoldIds
                            : orderState.leftEarmoldIds,
                    leftSelectedIds:
                        orderState.side !== 'R'
                            ? orderState.leftEarmoldIds
                            : orderState.rightEarmoldIds,
                },
                true,
                productDetailState.earmoldOptions,
                side === 'B'
                    ? sides.binaural
                    : side === 'R'
                    ? sides.right
                    : sides.left,
                stateResult
            );

            const temp = updateOptionsFromAudiogram(
                { ...orderState, ...stateResult.orderDetails },
                { ...productDetailState, ...stateResult.productDetails }
            );

            if (temp) {
                stateResult = {
                    ...stateResult,
                    orderDetails: {
                        ...stateResult.orderDetails!,
                        rightSelectedIds:
                            temp.orderDetails!.rightSelectedIds ||
                            stateResult.orderDetails!.rightSelectedIds,
                        leftSelectedIds:
                            temp.orderDetails!.leftSelectedIds ||
                            stateResult.orderDetails!.leftSelectedIds,
                        rightEarmoldIds: temp.orderDetails!.rightEarmoldIds,
                        leftEarmoldIds: temp.orderDetails!.leftEarmoldIds,
                    },
                };
            }
        } else {
            ///resetting earmold options when side changes as per old site
            stateResult = {
                ...stateResult,
                orderDetails: {
                    ...stateResult.orderDetails!,
                    showEarmoldForMonauralCros: undefined,
                    rightEarmoldIds: [],
                    leftEarmoldIds: [],
                    earmoldDesignId: undefined,
                },
                productDetails: {
                    ...stateResult.productDetails!,
                    earmoldOptions: [],
                },
            };
        }

        const standardFaceplates = findOption(
            5,
            stateResult.productDetails!.options
        );
        //making the selected color stick when side is changed
        if (standardFaceplates && stateResult) {
            const rightOptions =
                stateResult.orderDetails!.rightSelectedIds || [];
            const leftOptions = stateResult.orderDetails!.leftSelectedIds || [];
            standardFaceplates.items.forEach((x) => {
                if (rightOptions.includes(x.id)) {
                    rightOptions.splice(rightOptions.indexOf(x.id), 1);
                }
                if (leftOptions.includes(x.id)) {
                    leftOptions.splice(leftOptions.indexOf(x.id), 1);
                }
            });
            const rightStdFaceplates = standardFaceplates.items.find(
                (x) =>
                    x.name === productDetailState.color ||
                    orderState.rightSelectedIds.includes(x.id)
            );
            if (rightStdFaceplates) {
                rightOptions.push(rightStdFaceplates.id);
            }
            const leftStdFaceplates = standardFaceplates.items.find(
                (x) =>
                    x.name === productDetailState.color ||
                    orderState.leftSelectedIds.includes(x.id)
            );
            if (leftStdFaceplates) {
                leftOptions.push(leftStdFaceplates.id);
            }
        }

        // Bug 34089 - When side is set to left or right, only the receiver with that side should have a quantity > 0.
        // Server-side code then drops 0-quantity receiver(s) from the collection when updating cart.
        if (orderState!.receivers && side !== 'B') {
            orderState.receivers.forEach((x) => {
                if (x.side !== side) {
                    x.quantity = 0;
                }
            });

            stateResult = {
                ...stateResult,
                orderDetails: {
                    ...stateResult.orderDetails!,
                    receivers: orderState.receivers,
                },
            };
        }

        setOrderState((prevState) => ({
            ...prevState,
            ...stateResult.orderDetails,
            side: side,
            pairAid: null,
        }));

        setProductDetailState((prevState) => ({
            ...prevState,
            ...stateResult.productDetails,
        }));
    };

    const handleReceiverFitChange = (receiverFit: string) => {
        const cloned: IProductDetail = JSON.parse(
            JSON.stringify(productDetailState)
        );
        cloned.cartItemTypeId = getCartItemTypeID(receiverFit);
        let stateresult = runRules(
            { rightSelectedIds: [], leftSelectedIds: [] },
            false,
            getOptions(cloned.cartItemTypeId!)
        );

        const od = {
            ...orderState,
            cartItemTypeId: getCartItemTypeID(receiverFit),
            ...stateresult.orderDetails,
        };
        const pd = {
            ...productDetailState,
            ...stateresult.productDetails,
        };

        const temp = updateOptionsFromAudiogram(od, pd);

        if (temp) {
            stateresult = {
                ...stateresult,
                orderDetails: {
                    ...stateresult.orderDetails!,
                    rightSelectedIds:
                        temp.orderDetails!.rightSelectedIds ||
                        stateresult.orderDetails!.rightSelectedIds,
                    leftSelectedIds:
                        temp.orderDetails!.leftSelectedIds ||
                        stateresult.orderDetails!.leftSelectedIds,
                    rightEarmoldIds: temp.orderDetails!.rightEarmoldIds,
                    leftEarmoldIds: temp.orderDetails!.leftEarmoldIds,
                },
            };
        }

        const standardFaceplates = findOption(
            5,
            stateresult.productDetails!.options
        );
        ///making the selected color stick when receiverfit is changed
        if (standardFaceplates && stateresult) {
            const rightOptions =
                stateresult.orderDetails!.rightSelectedIds || [];
            const leftOptions = stateresult.orderDetails!.leftSelectedIds || [];
            standardFaceplates.items.forEach((x) => {
                if (rightOptions.includes(x.id)) {
                    rightOptions.splice(rightOptions.indexOf(x.id), 1);
                }
                if (leftOptions.includes(x.id)) {
                    leftOptions.splice(leftOptions.indexOf(x.id), 1);
                }
            });
            rightOptions.push(
                standardFaceplates.items.find(
                    (x) => x.name === productDetailState.color
                )!.id
            );
            leftOptions.push(
                standardFaceplates.items.find(
                    (x) => x.name === productDetailState.color
                )!.id
            );
        }

        ////resetting options and selections when receiver fit is changed
        setOrderState((prevState) => ({
            ...prevState,
            ...stateresult!.orderDetails,
            receiverFit: receiverFit,
            earmoldDesignId: undefined,
            showEarmoldForMonauralCros: undefined,
            cartItemTypeId: getCartItemTypeID(receiverFit),
        }));
        setProductDetailState((prevState) => ({
            ...prevState,
            ...stateresult!.productDetails,
            earmoldOptions: [],
        }));
    };

    const handleCrosEarmoldQuestion = (isEarmoldForCros: boolean) => {
        setOrderState((prevState) => ({
            ...prevState,
            showEarmoldForMonauralCros: isEarmoldForCros,
            earmoldDesignId: undefined,
            rightEarmoldIds: [],
            leftEarmoldIds: [],
        }));

        setProductDetailState((prevState) => ({
            ...prevState,
            earmoldOptions: [],
        }));
    };

    const handleStateResultChange = (stateResult: StateResult) => {
        const ruleTriggerKeys = ['rightSelectedIds'];

        const isEarmold = Boolean(stateResult.isEarmold);
        let ruleResult: StateResult = {};

        if (
            stateResult.orderDetails &&
            ruleTriggerKeys.some((k) =>
                stateResult.orderDetails!.hasOwnProperty(k)
            )
        ) {
            ruleResult = runRules(
                {
                    rightSelectedIds: stateResult.orderDetails.rightSelectedIds
                        ? stateResult.orderDetails.rightSelectedIds
                        : [],
                    leftSelectedIds: stateResult.orderDetails.leftSelectedIds
                        ? stateResult.orderDetails.leftSelectedIds
                        : [],
                },
                isEarmold,
                productDetailState!.options
            );
        }

        if (
            isEarmold &&
            stateResult.orderDetails &&
            stateResult.orderDetails.hasOwnProperty('rightSelectedIds')
        ) {
            stateResult.orderDetails.rightEarmoldIds =
                stateResult.orderDetails.rightSelectedIds;
            stateResult.orderDetails.leftEarmoldIds =
                stateResult.orderDetails.leftSelectedIds;

            stateResult.orderDetails.rightSelectedIds = [];
            stateResult.orderDetails.leftSelectedIds = [];
        }

        setProductDetailState((prevState) => ({
            ...prevState,
            ...stateResult.productDetails!,
            ...ruleResult.productDetails!,
        }));

        setOrderState((prevState) => ({
            ...prevState,
            ...stateResult.orderDetails!,
            ...ruleResult.orderDetails!,
        }));
    };

    const handleChange = (name: string, value: any) => {
        if (name === 'stateResult') {
            handleStateResultChange(value);
        } else {
            switch (name) {
                case 'orderType':
                    handleOrderTypeChange(value);
                    break;
                case 'side':
                    handleSideChange(value);
                    break;
                case 'receiverFit':
                    handleReceiverFitChange(value);
                    break;
                case 'earmoldDesignId':
                    handleEarmoldDesignIdChange(value);
                    break;
                case 'earmoldForCros':
                    handleCrosEarmoldQuestion(value);
                    break;
                default:
                    setOrderState((prevState) => ({
                        ...prevState,
                        [name]: value,
                    }));
                    break;
            }
        }
    };

    const getCartItemTypeID = (fitType: string) => {
        switch (fitType) {
            case receiverFitTypes.standard:
                if (
                    productDetailState!.cartItemTypeId === CartItemTypes.BteOnly
                ) {
                    return CartItemTypes.BteOnly;
                }
                if (
                    productDetailState!.cartItemTypeId ===
                    CartItemTypes.RicWithStockReceiver
                ) {
                    return CartItemTypes.RicWithStockReceiver;
                }
                break;

            case receiverFitTypes.earmold:
                if (
                    productDetailState!.cartItemTypeId === CartItemTypes.BteOnly
                ) {
                    return CartItemTypes.BteWithEarmold;
                }
                if (
                    productDetailState!.cartItemTypeId ===
                    CartItemTypes.RicWithStockReceiver
                ) {
                    return CartItemTypes.RicWithEarmold;
                }

                break;

            case receiverFitTypes.ap:
                if (
                    productDetailState!.cartItemTypeId ===
                    CartItemTypes.RicWithStockReceiver
                ) {
                    return CartItemTypes.RicWithAp;
                }

                break;

            default:
                break;
        }
    };

    // Note if the service just returned options on one property this wouldn't be necessary.
    const getOptions = (cartItemTypeId: number): IOption[] => {
        switch (cartItemTypeId) {
            case CartItemTypes.RicWithEarmold:
                return loadOptionsAndRules(productDetails!.ricEarmoldOptions);
            case CartItemTypes.RicWithAp:
                return loadOptionsAndRules(productDetails!.ricAPOptions);
            case CartItemTypes.BteWithEarmold:
                return loadOptionsAndRules(productDetails!.bteEarmoldOptions);
            default:
                return loadOptionsAndRules(productDetails!.options);
        }
    };

    const getInitialPatient = (
        transferPatient: InspireTransferPatient | undefined,
        patientDetails: IPatient | null,
        isAgreementOrder: boolean
    ): any => {
        const audiogramAsserter = function (x: any) {
            return ((x || '') + ',,,,,,,,,').split(',').slice(0, 10).join(',');
        };
        const speechRounder = function (x: string | undefined) {
            if (!x) return x;
            const parsed = parseInt(x);
            if (!parsed) return x;
            return `${getRoundedAudiogramValue(parsed)}`;
        };
        return transferPatient
            ? {
                  ageRange: transferPatient.ageRange,
                  firstName: transferPatient.firstName,
                  lastName: transferPatient.lastName,
                  agreement: isAgreementOrder,
                  agreementType: agreementName,
                  agreementInfo: agreementInfo,
                  audiogram: JSON.stringify(
                      transferPatient.audiogram
                          ? update(
                                {
                                    ...transferPatient.audiogram,
                                },
                                {
                                    right: {
                                        air: {
                                            curve: {
                                                $apply: audiogramAsserter,
                                            },
                                        },
                                        bone: {
                                            curve: {
                                                $apply: audiogramAsserter,
                                            },
                                        },
                                        MCL: {
                                            $apply: speechRounder,
                                        },
                                        UCL: {
                                            $apply: speechRounder,
                                        },
                                    },
                                    left: {
                                        air: {
                                            curve: {
                                                $apply: audiogramAsserter,
                                            },
                                        },
                                        bone: {
                                            curve: {
                                                $apply: audiogramAsserter,
                                            },
                                        },
                                        MCL: {
                                            $apply: speechRounder,
                                        },
                                        UCL: {
                                            $apply: speechRounder,
                                        },
                                    },
                                    MCL: {
                                        $apply: speechRounder,
                                    },
                                    UCL: {
                                        $apply: speechRounder,
                                    },
                                }
                            )
                          : {
                                right: {
                                    air: { curve: ',,,,,,,,,' },
                                    bone: { curve: ',,,,,,,,,' },
                                    MCL: null,
                                    UCL: null,
                                },
                                left: {
                                    air: { curve: ',,,,,,,,,' },
                                    bone: { curve: ',,,,,,,,,' },
                                    MCL: null,
                                    UCL: null,
                                },
                                MCL: null,
                                UCL: null,
                            }
                  ),
              }
            : {
                  ...patientDetails!,
                  agreement: isAgreementOrder,
                  agreementType: agreementName,
                  agreementInfo: agreementInfo,
                  audiogram: JSON.stringify({
                      right: {
                          air: { curve: ',,,,,,,,,' },
                          bone: { curve: ',,,,,,,,,' },
                          MCL: null,
                          UCL: null,
                      },
                      left: {
                          air: { curve: ',,,,,,,,,' },
                          bone: { curve: ',,,,,,,,,' },
                          MCL: null,
                          UCL: null,
                      },
                      MCL: null,
                      UCL: null,
                  }),
              };
    };

    const getInitialOrderType = (
        hasTransferPatient: boolean,
        isAgreementOrder: boolean
    ): string => {
        return (hasTransferPatient &&
            [
                CartItemTypes.BteOnly,
                CartItemTypes.RicWithStockReceiver,
                CartItemTypes.CustomOnly,
                CartItemTypes.Earmold,
                CartItemTypes.BteWithEarmold,
                CartItemTypes.RicWithEarmold,
                CartItemTypes.ApReceiver,
                CartItemTypes.RicWithAp,
                CartItemTypes.RicWithChr,
            ].includes(productDetails!.cartItemTypeId!)) ||
            isAgreementOrder ||
            [
                CartItemTypes.CustomOnly,
                CartItemTypes.Earmold,
                CartItemTypes.SoundGearEarmold,
                CartItemTypes.SoundGearCustom,
                CartItemTypes.ApReceiver,
            ].includes(productDetails!.cartItemTypeId!)
            ? 'patient'
            : 'bulk';
    };

    const getExistingCrosPairAid = () => {
        if (productDetails && productDetails.crosHearingAidTechnologies) {
            const selectedLeft = productDetails.existing.leftOptions.some(
                (x) => x === 511
            );
            const selectedRight = productDetails.existing.rightOptions.some(
                (x) => x === 511
            );
            let desc: string | undefined;
            if (
                selectedLeft &&
                productDetails.existing.side &&
                productDetails.existing.side.toLowerCase() === sides.binaural
            ) {
                desc = productDetails.existingPairAidDescription;
            } else if (selectedRight || selectedLeft) {
                desc = productDetails.existing.description;
            }
            if (desc) {
                return (
                    productDetails.crosHearingAidTechnologies.find(
                        (x) => x.description === desc
                    ) || null
                );
            }
        }
        return null;
    };

    //#region UseEffects
    usePiTracker();

    useEffect(() => {
        console.log('useEffect: constants');
        if (!constants) {
            loadConstants();
        }
    }, [constants]);
    useEffect(() => {
        return () => {
            clearProductDetails();
        };
    }, []);
    useEffect(() => {
        orderHold(order!.orderNumber, true);
    }, []);
    useEffect(() => {
        return () => {
            setSuccess(false);
            setConfirmed(false);
            setError(false);
            clearAdjustFeatures();
        };
    }, []);
    useEffect(() => {
        if (!adjustFeaturesResponse) return;

        if (adjustFeaturesResponse!.returnCodeType === 'Error') {
            setError(true);
        } else {
            setSuccess(true);
        }
    }, [adjustFeaturesResponse]);

    useEffect(() => {
        console.log('PRDODUCT DETAILS ', productDetails);
        if (productDetails) {
            document.title = productDetails.description; // TODO: move to use component

            const cloned: IProductDetail = JSON.parse(
                JSON.stringify(productDetails)
            );

            let stateResult: StateResult = {
                productDetails: {} as IProductDetail,
                orderDetails: {} as IOrderDetails,
            };

            if (!cloned.existing) {
                const selectedIds: ISelectedOptionIds = {
                    rightSelectedIds: [],
                    leftSelectedIds: [],
                };

                stateResult = runRules(
                    selectedIds,
                    false,
                    getOptions(productDetails.cartItemTypeId!)
                );
            }

            if (cloned.existing) {
                ///setting options from existing product
                stateResult.productDetails!.options = cloned.existing
                    .productOptions
                    ? cloned.existing.productOptions
                    : [];
                stateResult.productDetails!.earmoldOptions = cloned.existing
                    .earmoldOptions
                    ? cloned.existing.earmoldOptions
                    : [];

                ///setting options selection from existing product
                stateResult.orderDetails!.rightSelectedIds = cloned.existing
                    .rightOptions
                    ? cloned.existing.rightOptions
                    : [];
                stateResult.orderDetails!.leftSelectedIds = cloned.existing
                    .leftOptions
                    ? resetLeftCable(cloned.existing.leftOptions)
                    : [];
                stateResult.orderDetails!.rightEarmoldIds = [
                    CartItemTypes.Earmold,
                ].includes(cloned.existing.cartItemTypeId!)
                    ? cloned.existing.rightOptions
                        ? cloned.existing.rightOptions
                        : []
                    : cloned.existing.rightEarmoldIds
                    ? cloned.existing.rightEarmoldIds
                    : [];
                stateResult.orderDetails!.leftEarmoldIds = [
                    CartItemTypes.Earmold,
                ].includes(cloned.existing.cartItemTypeId!)
                    ? cloned.existing.leftOptions
                        ? cloned.existing.leftOptions
                        : []
                    : cloned.existing.leftEarmoldIds
                    ? resetLeftCable(cloned.existing.leftEarmoldIds)
                    : [];

                ///setting options on orderState from existing product
                stateResult.orderDetails!.productOptions = cloned.existing
                    .productOptions
                    ? cloned.existing.productOptions
                    : [];
                stateResult.orderDetails!.earmoldOptions = cloned.existing
                    .earmoldOptions
                    ? cloned.existing.earmoldOptions
                    : [];
            }

            let customDefaultImageUrl: string | undefined;

            if (
                productDetails.isCustom &&
                cloned.cartItemTypeId !== CartItemTypes.Earmold &&
                stateResult.orderDetails &&
                stateResult.productDetails
            ) {
                let faceplateColors: IOption[] = [];
                if (
                    [
                        CartItemTypes.CustomOnly,
                        CartItemTypes.SoundGearCustom,
                    ].includes(productDetails.cartItemTypeId!)
                ) {
                    faceplateColors = getCustomColorOptions(
                        stateResult.productDetails.options,
                        OptionTypes.FaceplateColor
                    );
                }

                const shellColors = getCustomColorOptions(
                    stateResult.productDetails.options,
                    OptionTypes.ShellColor
                );

                const shell = shellColors.find(
                    (x) =>
                        (cloned.existing &&
                            cloned.existing.side !== 'Left' &&
                            stateResult.orderDetails!.rightSelectedIds.includes(
                                x.id
                            )) ||
                        stateResult.orderDetails!.rightSelectedIds.includes(
                            x.id
                        ) ||
                        (cloned.existing &&
                            cloned.existing!.side !== 'Right' &&
                            stateResult.orderDetails!.leftSelectedIds.includes(
                                x.id
                            )) ||
                        stateResult.orderDetails!.leftSelectedIds.includes(x.id)
                );
                const faceplate = faceplateColors.find(
                    (x) =>
                        (cloned.existing &&
                            cloned.existing.side !== 'Left' &&
                            stateResult.orderDetails!.rightSelectedIds.includes(
                                x.id
                            )) ||
                        stateResult.orderDetails!.rightSelectedIds.includes(
                            x.id
                        ) ||
                        (cloned.existing &&
                            cloned.existing!.side !== 'Right' &&
                            stateResult.orderDetails!.leftSelectedIds.includes(
                                x.id
                            )) ||
                        stateResult.orderDetails!.leftSelectedIds.includes(x.id)
                );

                if (shell) {
                    stateResult.productDetails!.shellColor = shell!.name;
                }

                if (faceplate) {
                    stateResult.productDetails!.faceplateColor =
                        faceplate!.name;
                }

                const faceplateObjects = prepareCustomColors(
                    faceplateColors,
                    orderState.side
                );
                const shellObjects = prepareCustomColors(
                    shellColors,
                    orderState.side
                );

                customDefaultImageUrl = prepareCustomImageUrl(
                    productDetails.imageBase,
                    faceplateObjects,
                    shellObjects,
                    faceplate
                        ? faceplateObjects.find((x) => x.id === faceplate.id)
                        : undefined,
                    shell
                        ? shellObjects.find((x) => x.id === shell.id)
                        : undefined
                );
            }

            const newProductDetailState = {
                longDescription: [CartItemTypes.ApReceiver].includes(
                    cloned.cartItemTypeId!
                )
                    ? productDetails.compatibility
                    : productDetails.longDescription,
                color: productDetails.existing
                    ? productDetails.existing.color
                    : productDetails.defaultColor,
                imageUrl: productDetails.existing
                    ? productDetails.existing.imageUrl
                    : customDefaultImageUrl || productDetails.imageUrl,
                imageBase: productDetails.imageBase,
                standardColors: ![
                    CartItemTypes.CustomOnly,
                    CartItemTypes.Earmold,
                    CartItemTypes.ApReceiver,
                    CartItemTypes.SoundGear,
                    CartItemTypes.SoundGearCustom,
                    CartItemTypes.SoundGearEarmold,
                ].includes(productDetails!.cartItemTypeId!)
                    ? cloned.standardColors.filter((x) => {
                          return cloned.options
                              .find((x) => x.id === 10)!
                              .items[0].items.map((y) => {
                                  return y.name;
                              })
                              .includes(x.color);
                      })
                    : [],
                isCros:
                    productDetails!.cros ||
                    APIDs.some((x) => {
                        return findOption(x, productDetails!.options)
                            ? true
                            : false;
                    }),
                existing: productDetails.existing,
            };

            setProductDetailState({
                ...cloned,
                ...newProductDetailState,
                ...stateResult.productDetails!,
            });

            if (productDetails.isCustom && stateResult.productDetails) {
                prepareFaceplatesAndShells(stateResult.productDetails.options);
            }

            if (productDetails.existing) {
                setOrderState({
                    ...orderState!,
                    itemGuid: productDetails.existing.itemGuid,
                    baseProductId: productDetails.baseProductId,
                    partNumber: productDetails.existing.partNumber,
                    orderType:
                        productDetails.existing.orderType === 'Patient Order'
                            ? 'patient'
                            : 'bulk',
                    quantity:
                        productDetails.existing.orderType === 'Patient Order'
                            ? 0
                            : parseInt(
                                  productDetails.existing.quantity.toString()
                              ),
                    side:
                        productDetails.existing.side === 'Binaural'
                            ? 'B'
                            : productDetails.existing.side === 'Right'
                            ? 'R'
                            : productDetails.existing.side === 'Left' &&
                              productDetails.existing.orderType ===
                                  'Patient Order'
                            ? 'L'
                            : null,
                    cartItemTypeId: productDetails.existing.cartItemTypeId,
                    catalogId: productDetails.catalogId,
                    earmoldCategory: productDetails.earmoldCategory,
                    existingItemId: productDetails.existing.itemID,
                    isCustom: productDetails.isCustom,
                    pageGuid: productDetails.pageGuid,
                    selectedImage: productDetails.existing.imageUrl,
                    selectedColor: productDetails.existing.color,
                    selectedItemNumber: productDetails.existing.partNumber,
                    designId: productDetails.designId,
                    productUrl: productDetails.url,
                    description: productDetails.description,
                    brand: productDetails.brand,
                    ampQuantityLeft: 0,
                    patient: {
                        ...productDetails.existing.patient!,
                        id: null,
                        audiogram:
                            productDetails.existing.patient! &&
                            productDetails.existing.patient!.audiogram
                                ? productDetails.existing.patient!.audiogram
                                : JSON.stringify({
                                      right: {
                                          air: { curve: ',,,,,,,,,' },
                                          bone: { curve: ',,,,,,,,,' },
                                          MCL: null,
                                          UCL: null,
                                      },
                                      left: {
                                          air: { curve: ',,,,,,,,,' },
                                          bone: { curve: ',,,,,,,,,' },
                                          MCL: null,
                                          UCL: null,
                                      },
                                      MCL: null,
                                      UCL: null,
                                  }),
                    },
                    receivers: cloned.existing.receivers,
                    accessories: cloned.existing.accessories,
                    thinTubes: cloned.existing.thinTubes,
                    showSpecialInstructions:
                        productDetails.existing.specialInstructions &&
                        productDetails.existing.specialInstructions !== ''
                            ? true
                            : false,
                    specialInstructions:
                        productDetails.existing.specialInstructions,
                    cros: productDetails.cros,
                    pairAid: getExistingCrosPairAid(),
                    warranty: productDetails.existing.warranty,
                    earmoldDesignId: productDetails.existing.earmoldDesignId!,
                    receiverFit: [
                        CartItemTypes.BteOnly,
                        CartItemTypes.RicWithStockReceiver,
                    ].includes(productDetails.existing.cartItemTypeId!)
                        ? receiverFitTypes.standard
                        : [
                              CartItemTypes.BteWithEarmold,
                              CartItemTypes.RicWithEarmold,
                          ].includes(productDetails.existing.cartItemTypeId!)
                        ? receiverFitTypes.earmold
                        : [CartItemTypes.RicWithAp].includes(
                              productDetails.existing.cartItemTypeId!
                          )
                        ? receiverFitTypes.ap
                        : null,
                    impressions: productDetails.existing.patient
                        ? productDetails.existing.patient!.scanOnFileLeft ||
                          productDetails.existing.patient!.scanOnFileRight
                            ? 'Use digital impressions on file'
                            : productDetails.existing.patient!
                                  .otoscanPackageId1 ||
                              productDetails.existing.patient!.otoscanPackageId2
                            ? 'Direct ear scan'
                            : productDetails.existing.patient!.impressionLeft ||
                              productDetails.existing.patient!.impressionRight
                            ? 'Attach digital impressions'
                            : 'Send physical impressions'
                        : null,
                    ...stateResult.orderDetails,
                });
            } else {
                const transferPatient = parseTransferPatient(
                    cookies.transferPatient
                );
                const isAgreementOrder = agreementName.length > 0;
                const initialOrderType = getInitialOrderType(
                    !!transferPatient,
                    isAgreementOrder
                );
                const newOrderState = {
                    itemGuid: productDetails.itemGuid,
                    baseProductId: productDetails.baseProductId,
                    partNumber: productDetails.partNumber,
                    orderType: initialOrderType,
                    quantity: 1,
                    side: initialOrderType === 'patient' ? 'B' : null,
                    cartItemTypeId: productDetails.cartItemTypeId,
                    earmoldCategory: productDetails.earmoldCategory,
                    catalogId: productDetails.catalogId,
                    existingItemId: '-1',
                    isCustom: productDetails.isCustom,
                    pageGuid: productDetails.pageGuid,
                    selectedImage:
                        customDefaultImageUrl || productDetails.imageUrl,
                    selectedColor: productDetails.defaultColor,
                    selectedItemNumber: productDetails.partNumber,
                    designId: productDetails.designId,
                    productUrl: productDetails.url,
                    description: productDetails.description,
                    brand: productDetails.brand,
                    patient: getInitialPatient(
                        transferPatient,
                        patientDetails,
                        isAgreementOrder
                    ),
                    receiverFit: receiverFitTypes.standard,
                    receivers:
                        initialOrderType === 'patient'
                            ? null
                            : [CartItemTypes.RicWithStockReceiver].includes(
                                  productDetails!.cartItemTypeId!
                              ) &&
                              productDetails!.options.find((x) => x.id === 19)
                            ? [
                                  {
                                      ...receiver!,
                                      useAngledParts: true,
                                      quantity: 1,
                                  },
                              ]
                            : null,
                    accessories: [],
                    thinTubes: [],
                    showSpecialInstructions: false,
                    specialInstructions: null,
                    cros: productDetails.cros,
                    warranty: 0,
                };
                setOrderState({
                    ...orderState,
                    ...newOrderState,
                    ...stateResult.orderDetails!,
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [productDetails && productDetails.itemGuid]);

    useEffect(() => {
        console.log(
            'useEffect: productDetailState.isCustom, productDetailState.options'
        );
        if (productDetailState.isCustom) {
            prepareFaceplatesAndShells(productDetailState.options);
        }
    }, [productDetailState.isCustom, productDetailState.options]);

    useEffect(() => {
        console.log('useEffect: orderState');
        if (Object.keys(errorsState).length > 0) {
            const errors = IsValid(
                orderState,
                productDetailState,
                patientNumberRequired,
                session.country,
                true,
                session.siteNumber,
                intl
            );
            setErrorsState(errors);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [orderState]);

    console.log(orderState);
    console.log(productDetailState);
    console.log(
        orderState!.rightSelectedIds
            ? orderState!.rightSelectedIds.sort((a, b) => a - b)
            : []
    );
    console.log(
        orderState!.leftSelectedIds
            ? orderState!.leftSelectedIds.sort((a, b) => a - b)
            : []
    );
    console.log(
        orderState!.rightEarmoldIds
            ? orderState!.rightEarmoldIds.sort((a, b) => a - b)
            : []
    );
    console.log(
        orderState!.leftEarmoldIds
            ? orderState!.leftEarmoldIds.sort((a, b) => a - b)
            : []
    );

    //#endregion

    return (
        <>
            {!confirmed ? (
                <ModalXLarge>
                    <>
                        <div className="modal-header">
                            <button
                                type="button"
                                className="close"
                                id="closeModalAdjustModal"
                                data-dismiss="modal"
                                aria-label={intl.formatMessage({
                                    id: 'Close',
                                })}
                                onClick={onClose}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="container modal-content-xl">
                            {productDetails &&
                                Object.keys(productDetailState).length > 0 &&
                                Object.keys(orderState).length > 0 && (
                                    <form
                                        style={{ marginBottom: '60px' }}
                                        noValidate={true}
                                    >
                                        <div className="row row-m-b">
                                            <div className="col-md-8">
                                                <div className="row row-m-b">
                                                    <h2
                                                        className="col-md-12 no-text-transform"
                                                        id="update-details-product-name"
                                                    >
                                                        {
                                                            productDetails.description
                                                        }
                                                    </h2>
                                                </div>
                                                <div
                                                    className="row row-m-b"
                                                    style={{
                                                        fontSize: '20px',
                                                    }}
                                                >
                                                    <div className="col-md-6">
                                                        {![
                                                            CartItemTypes.ApReceiver,
                                                            CartItemTypes.Earmold,
                                                            CartItemTypes.CustomOnly,
                                                            CartItemTypes.SoundGearCustom,
                                                            CartItemTypes.SoundGearEarmold,
                                                        ].includes(
                                                            orderState.cartItemTypeId!
                                                        ) && (
                                                            <span id="update-details-part-number">
                                                                {intl.formatMessage(
                                                                    {
                                                                        id: 'Part_#',
                                                                        defaultMessage:
                                                                            'Part #',
                                                                    }
                                                                )}{' '}
                                                                {
                                                                    orderState.partNumber
                                                                }
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                {orderState &&
                                                    orderState.patient &&
                                                    orderState.patient
                                                        .agreementType && (
                                                        <div
                                                            className="row row-m-b"
                                                            style={{
                                                                display: 'flex',
                                                                margin: '10px 0px',
                                                                border: '2px solid #1e9be9',
                                                            }}
                                                        >
                                                            <div
                                                                className="col-md-8"
                                                                style={{
                                                                    alignItems:
                                                                        'center',
                                                                    padding:
                                                                        '3%',
                                                                }}
                                                            >
                                                                <span>
                                                                    {orderState
                                                                        .patient
                                                                        .agreementType +
                                                                        ': ' +
                                                                        orderState
                                                                            .patient
                                                                            .agreementInfo}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    )}

                                                <div className="row row-m-b">
                                                    <div className="col-md-12">
                                                        <LongDescription
                                                            description={
                                                                productDetailState!
                                                                    .longDescription
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                {![
                                                    CartItemTypes.ApReceiver,
                                                    CartItemTypes.Earmold,
                                                    CartItemTypes.SoundGearEarmold,
                                                ].includes(
                                                    orderState.cartItemTypeId!
                                                ) && (
                                                    <>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p>
                                                                    <b>
                                                                        {productDetails.isCustom ? (
                                                                            <FormattedMessage
                                                                                id="Faceplate_Color"
                                                                                defaultMessage="Faceplate Color"
                                                                            />
                                                                        ) : (
                                                                            <FormattedMessage
                                                                                id="Case_Color"
                                                                                defaultMessage="Case Color"
                                                                            />
                                                                        )}{' '}
                                                                    </b>
                                                                    {'  '}
                                                                    {productHoverImage &&
                                                                    productHoverImage.color
                                                                        ? productHoverImage.color
                                                                        : productDetails.isCustom
                                                                        ? productDetailState.faceplateColor
                                                                        : productDetailState.color}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <ColorSelector
                                                                    name={
                                                                        productDetails.isCustom
                                                                            ? 'CustomColorPlate'
                                                                            : 'ColorSelection'
                                                                    }
                                                                    faceplates={
                                                                        faceplates
                                                                    }
                                                                    shells={
                                                                        shells
                                                                    }
                                                                    orderState={
                                                                        orderState
                                                                    }
                                                                    productDetails={
                                                                        productDetailState
                                                                    }
                                                                    onHover={
                                                                        handleFacePlateImageHover
                                                                    }
                                                                    onChange={
                                                                        handleStateResultChange
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                {[
                                                    CartItemTypes.CustomOnly,
                                                    CartItemTypes.ApReceiver,
                                                    CartItemTypes.SoundGearCustom,
                                                ].includes(
                                                    orderState.cartItemTypeId!
                                                ) && (
                                                    <>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <p>
                                                                    <b>
                                                                        <FormattedMessage
                                                                            id="Shell_Color"
                                                                            defaultMessage="Shell Color"
                                                                        />
                                                                    </b>
                                                                    {'  '}

                                                                    {productHoverImage &&
                                                                    productHoverImage.shellColor
                                                                        ? productHoverImage.shellColor
                                                                        : productDetailState.shellColor}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="row">
                                                            <div className="col-md-12">
                                                                <ColorSelector
                                                                    name={
                                                                        'CustomColorShell'
                                                                    }
                                                                    faceplates={
                                                                        faceplates
                                                                    }
                                                                    shells={
                                                                        shells
                                                                    }
                                                                    orderState={
                                                                        orderState
                                                                    }
                                                                    productDetails={
                                                                        productDetailState
                                                                    }
                                                                    useShellsForCustom={
                                                                        true
                                                                    }
                                                                    onHover={
                                                                        handleFacePlateImageHover
                                                                    }
                                                                    onChange={
                                                                        handleStateResultChange
                                                                    }
                                                                />
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {/* <div className="row">
                                                    <div
                                                        className="col-md-12"
                                                        style={{
                                                            zIndex: 1
                                                        }}
                                                    >
                                                        {productDetailState!
                                                            .inventoryStatuses ? (
                                                            <>
                                                                {productDetailState!.inventoryStatuses
                                                                    .filter(
                                                                        s =>
                                                                            s.partNumber ===
                                                                            productDetailState.partNumber
                                                                    )
                                                                    .map(x => {
                                                                        return (
                                                                            <h4
                                                                                style={{
                                                                                    color:
                                                                                        x.statusColor
                                                                                }}
                                                                                key={
                                                                                    x.status
                                                                                }
                                                                            >
                                                                                <i className="fad fa-check" />{' '}
                                                                                {
                                                                                    x.statusText
                                                                                }
                                                                            </h4>
                                                                        );
                                                                    })}
                                                            </>
                                                        ) : (
                                                            <h4 className="text-green">
                                                                <i className="fad fa-check"></i>
                                                                Estimated to
                                                                ship in 3-5
                                                                business days
                                                            </h4>
                                                        )}
                                                    </div>
                                                </div> */}
                                            </div>
                                            <div className="col-md-4">
                                                <div className="row">
                                                    <img
                                                        style={{
                                                            height: '320px',
                                                        }}
                                                        src={
                                                            productHoverImage &&
                                                            productHoverImage.imageUrl
                                                                ? productHoverImage.imageUrl
                                                                : [
                                                                      CartItemTypes.Earmold,
                                                                      CartItemTypes.SoundGearEarmold,
                                                                  ].includes(
                                                                      productDetailState!
                                                                          .cartItemTypeId!
                                                                  ) &&
                                                                  orderState!
                                                                      .earmoldDesignId
                                                                ? `/services/catalogs/${
                                                                      session!
                                                                          .catalog
                                                                  }/designs/${
                                                                      orderState!
                                                                          .earmoldDesignId ||
                                                                      productDetailState!.earmolds.find(
                                                                          (x) =>
                                                                              x.key ===
                                                                              productDetailState!
                                                                                  .earmoldCategory
                                                                      )!
                                                                          .items[0]
                                                                          .designId
                                                                  }/image`
                                                                : productDetailState!
                                                                      .imageUrl
                                                        }
                                                        alt="Unavailable"
                                                    />
                                                </div>
                                                <div className="row">
                                                    <div>
                                                        <button
                                                            id="update-details-favorite-btn"
                                                            type="button"
                                                            className="btn-link"
                                                            onClick={() =>
                                                                handleToggleFavorite(
                                                                    productDetails.baseProductId
                                                                )
                                                            }
                                                        >
                                                            {isFavorite(
                                                                productDetails.baseProductId
                                                            ) ? (
                                                                <>
                                                                    <i
                                                                        className={
                                                                            'fas fa-star fa-lg'
                                                                        }
                                                                    />
                                                                    {' ' +
                                                                        intl.formatMessage(
                                                                            {
                                                                                id: 'Favorite',
                                                                                defaultMessage:
                                                                                    'Favorite',
                                                                            }
                                                                        )}
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <i
                                                                        className={
                                                                            'far fa-star fa-lg'
                                                                        }
                                                                    />
                                                                    {' ' +
                                                                        intl.formatMessage(
                                                                            {
                                                                                id: 'Add_To_Favorites',
                                                                                defaultMessage:
                                                                                    'Add To Favorites',
                                                                            }
                                                                        )}
                                                                </>
                                                            )}
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {Object.keys(errorsState).length >
                                            0 && (
                                            <RowElementWrapper>
                                                <div ref={errorRef}>
                                                    <ErrorsMessageBox
                                                        errors={errorsState}
                                                    />
                                                </div>
                                            </RowElementWrapper>
                                        )}

                                        {([
                                            CartItemTypes.CustomOnly,
                                            CartItemTypes.BteWithEarmold,
                                            CartItemTypes.RicWithEarmold,
                                            CartItemTypes.RicWithAp,
                                            CartItemTypes.ApReceiver,
                                        ].includes(
                                            orderState!.cartItemTypeId!
                                        ) ||
                                            [
                                                'RIC Earmold',
                                                'Standard Earmold',
                                                'Thin Tube Earmold',
                                            ].includes(
                                                productDetailState!
                                                    .earmoldCategory
                                            )) && (
                                            <div>
                                                <RowElementWrapper>
                                                    <h2 className="no-text-transform">
                                                        <FormattedMessage
                                                            id="Audiogram"
                                                            defaultMessage="Audiogram"
                                                        />
                                                    </h2>
                                                </RowElementWrapper>
                                                <RowElementWrapper>
                                                    <ThresholdSection
                                                        selectedSide={
                                                            orderState!.side!
                                                        }
                                                        patientDetails={
                                                            orderState!.patient!
                                                        }
                                                        onChange={
                                                            updatePatientDetails
                                                        }
                                                        productDetails={
                                                            productDetailState!
                                                        }
                                                        updateStarkeyChoiceOrHearingLoss={
                                                            updateStarkeyChoiceOrHearingLoss
                                                        }
                                                        errors={errorsState}
                                                    />
                                                </RowElementWrapper>
                                            </div>
                                        )}
                                        {productDetailState!.options &&
                                            findOption(
                                                'Starkey Choice',
                                                productDetailState!.options
                                            ) && (
                                                <>
                                                    <RowElementWrapper>
                                                        <h2 className="no-text-transform">
                                                            <FormattedMessage
                                                                id="Custom_Options"
                                                                defaultMessage="Custom Options"
                                                            />
                                                        </h2>
                                                    </RowElementWrapper>
                                                    <RowElementWrapper>
                                                        <h3 className="no-text-transform">
                                                            {intl.formatMessage(
                                                                {
                                                                    id: 'Manufacturer_Select',
                                                                    defaultMessage:
                                                                        'Manufacturer Select',
                                                                }
                                                            )}
                                                        </h3>
                                                        <RowElementWrapper>
                                                            <StarkeyChoice
                                                                options={
                                                                    findOption(
                                                                        'Starkey Choice',
                                                                        productDetailState!
                                                                            .options
                                                                    )!.items
                                                                }
                                                                selectedIds={{
                                                                    rightSelectedIds:
                                                                        orderState!
                                                                            .rightSelectedIds,
                                                                    leftSelectedIds:
                                                                        orderState!
                                                                            .leftSelectedIds,
                                                                }}
                                                                onChange={
                                                                    handleOptionsChange
                                                                }
                                                                side={
                                                                    orderState!
                                                                        .side!
                                                                }
                                                            />
                                                        </RowElementWrapper>
                                                    </RowElementWrapper>
                                                </>
                                            )}
                                        {/* Product Order Info Section End */}
                                        {/* Product Options Section Start */}
                                        {productDetailState!.options &&
                                            productDetailState!.options.length >
                                                0 && (
                                                <>
                                                    {' '}
                                                    <RowElementWrapper>
                                                        <h2 className="no-text-transform">
                                                            <FormattedMessage
                                                                id="Product_Options"
                                                                defaultMessage="Product Options"
                                                            />
                                                        </h2>
                                                    </RowElementWrapper>
                                                    <RowElementWrapper>
                                                        <ProductOptions
                                                            options={
                                                                productDetailState!
                                                                    .options
                                                            }
                                                            productDetails={
                                                                productDetailState!
                                                            }
                                                            orderDetails={
                                                                orderState!
                                                            }
                                                            updateSelectedOptions={
                                                                handleOptionsChange
                                                            }
                                                            isEarmold={false}
                                                            updateCrosPairAid={(
                                                                pairAid
                                                            ) =>
                                                                setOrderState(
                                                                    (
                                                                        prevState
                                                                    ) => ({
                                                                        ...prevState!,
                                                                        pairAid:
                                                                            pairAid
                                                                                ? pairAid
                                                                                : null,
                                                                    })
                                                                )
                                                            }
                                                            errors={errorsState}
                                                            isUpdateDetails={
                                                                true
                                                            }
                                                        />
                                                    </RowElementWrapper>
                                                </>
                                            )}
                                        {/* Product Options Section End */}

                                        {/* Earmold Options Section Start */}
                                        {(([
                                            CartItemTypes.BteWithEarmold,
                                            CartItemTypes.RicWithEarmold,
                                        ].includes(
                                            orderState!.cartItemTypeId!
                                        ) &&
                                            productDetailState!.earmolds) ||
                                            ([
                                                CartItemTypes.Earmold,
                                                CartItemTypes.SoundGearEarmold,
                                            ].includes(
                                                orderState!.cartItemTypeId!
                                            ) &&
                                                orderState!
                                                    .earmoldDesignId)) && (
                                            <>
                                                <RowElementWrapper>
                                                    <h2 className="no-text-transform">
                                                        <FormattedMessage
                                                            id="Earmold Options"
                                                            defaultMessage="Earmold Options"
                                                        />
                                                    </h2>
                                                </RowElementWrapper>
                                                <RowElementWrapper>
                                                    <EarmoldOptions
                                                        earmolds={
                                                            productDetailState!
                                                                .earmolds
                                                        }
                                                        productDetails={
                                                            productDetailState
                                                        }
                                                        orderDetails={
                                                            orderState!
                                                        }
                                                        onChange={handleChange}
                                                        session={session}
                                                        updateSelectedOptions={
                                                            handleOptionsChange
                                                        }
                                                        // TODO: fix this update chain
                                                        updateOptionsOnProductDetailState={(
                                                            options,
                                                            isEarmold
                                                        ) => {
                                                            handleOptionsChange(
                                                                productDetailState.existing
                                                                    ? orderState.rightEarmoldIds
                                                                    : [],
                                                                productDetailState.existing
                                                                    ? orderState.leftEarmoldIds
                                                                    : [],
                                                                isEarmold,
                                                                options
                                                            );
                                                        }}
                                                        updateCrosPairAid={(
                                                            pairAid
                                                        ) =>
                                                            handleChange(
                                                                'pairAid',
                                                                pairAid
                                                                    ? pairAid
                                                                    : null
                                                            )
                                                        }
                                                        errors={errorsState}
                                                    />
                                                </RowElementWrapper>
                                            </>
                                        )}
                                        {/* Earmold Options Section End */}
                                        {/** 
                                {!!orderState &&
                                    ![
                                        CartItemTypes.Earmold,
                                        CartItemTypes.SoundGear,
                                        CartItemTypes.SoundGearCustom,
                                        CartItemTypes.DashTailored,
                                        CartItemTypes.FacePlates
                                    ].includes(orderState.cartItemTypeId!) && (
                                        <WarrantySection
                                            name="WarrantySelection"
                                            selectedWarranty={
                                                orderState!.warranty
                                            }
                                            defaultWarranty={
                                                productDetails!.defaultWarranty
                                            }
                                            onChange={e => {
                                                e.persist();
                                                setOrderState(prevState => ({
                                                    ...prevState!,
                                                    warranty: e.target.checked
                                                        ? parseInt(
                                                              e.target.value
                                                          )
                                                        : 0
                                                }));
                                            }}
                                            showExtendedWarranty={
                                                ![
                                                    CartItemTypes.Earmold,
                                                    CartItemTypes.Accessory,
                                                    CartItemTypes.SoundGearEarmold
                                                ].includes(
                                                    orderState!.cartItemTypeId!
                                                ) &&
                                                orderState.orderType ===
                                                    'patient'
                                            }
                                        />
                                )}
                            */}
                                        <div className="add-to-cart-section">
                                            {[
                                                CartItemTypes.CustomOnly,
                                                CartItemTypes.Earmold,
                                                CartItemTypes.BteWithEarmold,
                                                CartItemTypes.RicWithEarmold,
                                                CartItemTypes.RicWithAp,
                                                CartItemTypes.ApReceiver,
                                                CartItemTypes.SoundGearEarmold,
                                                CartItemTypes.SoundGearCustom,
                                                CartItemTypes.FacePlates,
                                            ].includes(
                                                orderState!.cartItemTypeId!
                                            ) && (
                                                <div className="row row-m-b">
                                                    <div
                                                        className="col-md-12"
                                                        style={{
                                                            textAlign: 'center',
                                                        }}
                                                    >
                                                        <SpecialInstructions
                                                            name={
                                                                'specialInstructions'
                                                            }
                                                            orderDetails={
                                                                orderState
                                                            }
                                                            showHideSpecialInstructions={(
                                                                show
                                                            ) => {
                                                                handleChange(
                                                                    'showSpecialInstructions',
                                                                    show
                                                                );
                                                            }}
                                                            onChange={(e) => {
                                                                handleChange(
                                                                    'specialInstructions',
                                                                    e.target
                                                                        .value
                                                                );
                                                            }}
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                            <div className="row row-m-b">
                                                <div className="col-md-8" />
                                                <div className="col-md-4">
                                                    {/* {productDetailState!
                                                        .inventoryStatuses ? (
                                                        <>
                                                            {productDetailState!.inventoryStatuses
                                                                .filter(
                                                                    s =>
                                                                        s.partNumber ===
                                                                        productDetailState.partNumber
                                                                )
                                                                .map(x => {
                                                                    return (
                                                                        <h4
                                                                            style={{
                                                                                color:
                                                                                    x.statusColor
                                                                            }}
                                                                            key={
                                                                                x.status
                                                                            }
                                                                        >
                                                                            <i className="fad fa-check" />{' '}
                                                                            {
                                                                                x.statusText
                                                                            }
                                                                        </h4>
                                                                    );
                                                                })}
                                                        </>
                                                    ) : (
                                                        <h4 className="text-green">
                                                            <i className="fad fa-check"></i>
                                                            Estimated to ship in
                                                            3-5 business days
                                                        </h4>
                                                    )} */}

                                                    <button
                                                        className="btn btn-lg btn-primary "
                                                        onClick={addItemToOrder}
                                                    >
                                                        {addingToCart
                                                            ? intl.formatMessage(
                                                                  {
                                                                      id: 'Saving',
                                                                      defaultMessage:
                                                                          'Saving',
                                                                  }
                                                              ) + '...'
                                                            : intl.formatMessage(
                                                                  {
                                                                      id: 'Save_Changes',
                                                                      defaultMessage:
                                                                          'Save Changes',
                                                                  }
                                                              )}
                                                    </button>
                                                </div>
                                                <div className="col-md-2" />
                                            </div>
                                        </div>
                                    </form>
                                )}
                        </div>
                    </>
                </ModalXLarge>
            ) : (
                <Modal>
                    <>
                        <div className="modal-header">
                            <button
                                type="button"
                                className="close"
                                id="closeModalAdjustModal"
                                data-dismiss="modal"
                                aria-label={intl.formatMessage({
                                    id: 'Close',
                                })}
                                onClick={onClose}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <>
                            {!success && !error && (
                                <p className="text-center modal-spacing">
                                    <FormattedMessage
                                        id="updating_may_adjust_features"
                                        defaultMessage="Updating your order may impact your expected
                                    ship date. We will notify you if your
                                    expected ship date changes."
                                    />

                                    <br />
                                    <strong className="text-center modal-spacing">
                                        <FormattedMessage
                                            id="Are_you_sure_you_want_to_continue"
                                            defaultMessage="Are you sure you want to continue?"
                                        />
                                    </strong>
                                </p>
                            )}
                            {success && !error && (
                                <>
                                    <p className="text-center">
                                        <span className="fa fa-check icon-green"></span>
                                        <strong className="text-center modal-spacing">
                                            <FormattedMessage
                                                id="success_adjust_features"
                                                defaultMessage="Your features have successfully been
                                            updated."
                                            />
                                        </strong>
                                    </p>
                                </>
                            )}
                            {!success && error && (
                                <>
                                    <p className="text-center">
                                        <strong>
                                            <FormattedMessage
                                                id="we're_sorry_adjust_features"
                                                defaultMessage="We’re sorry there’s been an error
                                            adjusting features. Please try again"
                                            />
                                        </strong>
                                    </p>
                                </>
                            )}
                        </>

                        <div className="modal-footer">
                            {!success && (
                                <button
                                    type="button"
                                    className="btn btn-default"
                                    id="cancelButtonAdjustModal"
                                    onClick={onClose}
                                >
                                    <FormattedMessage
                                        id="Cancel"
                                        defaultMessage="Cancel"
                                    />
                                </button>
                            )}
                            {!success && !error && (
                                <button
                                    className="btn btn-info"
                                    onClick={addItemToOrder}
                                >
                                    <FormattedMessage
                                        id="Confirm"
                                        defaultMessage="Confirm"
                                    />
                                </button>
                            )}
                            {success && !error && (
                                <button
                                    className="btn btn-info"
                                    onClick={onAccept}
                                >
                                    <FormattedMessage
                                        id="Close"
                                        defaultMessage="Close"
                                    />
                                </button>
                            )}
                            {!success && error && (
                                <button
                                    className="btn btn-info"
                                    onClick={() => {
                                        setError(false);
                                        setConfirmed(false);
                                    }}
                                >
                                    <FormattedMessage
                                        id="Back"
                                        defaultMessage="Back"
                                    />
                                </button>
                            )}
                        </div>
                    </>
                </Modal>
            )}
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {
        cartId: state.updateOptionData!.cart.id,
        productId: state.updateOptionData!.cartItem.baseProductId,
        productDetails: state.productDetails
            ? state.productDetails.data!
            : null,
        agreementName:
            state.updateOptionData!.patient &&
            state.updateOptionData!.patient.agreementType !== ''
                ? state.updateOptionData!.patient.agreementType
                : '',
        agreementInfo:
            state.updateOptionData!.patient &&
            state.updateOptionData!.patient.agreementInfo !== ''
                ? state.updateOptionData!.patient.agreementInfo
                : '',
        patientNumberRequired:
            state.updateOptionData!.patient &&
            state.updateOptionData!.patient.agreement
                ? state.updateOptionData!.patient.agreement
                : false,
        session: state.session!.data!,
        constants: state.constants,
        spaPath: state.spaPath,
        updateOptionData: state.updateOptionData
            ? state.updateOptionData
            : null,
        order: state.order ? state.order.data! : null,
        adjustFeaturesResponse: state.adjustFeaturesResponse
            ? state.adjustFeaturesResponse.data
            : null,
    };
};

const mapDispatchToProps = {
    clearProductDetails,
    loadProductDetails,
    setIsBusy,
    loadConstants,
    loadSession,
    addToCart,
    adjustFeaturesAction,
    clearAdjustFeatures,
};
/* this area is structured slightly differently than other components
when building this page, I imported the product-details page and had import errors
so I rebuilt how redux state and local state are exported from this component */
const connector = connect(mapStateToProps, mapDispatchToProps);
const updateDetailsContainer = connector(UpdateDetails);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(updateDetailsContainer);
